<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <add-edit-slow-zone-area />
    <div class="flex flex-wrap" v-if="slow_zone_area != null">
      <div :class="is_full ? 'w-0' : 'w-1/2 px-6 py-4 bg-white md-max:w-full'">
        <div class="flex flex-wrap items-center">
          <div class="flex items-center w-2/3 pl-2 md-max:w-full">
            <div
              class="items-center justify-center mr-4 cursor-pointer back-button"
              @click="goBack"
            >
              <i class="fas fa-arrow-left"></i>
            </div>
            <span class="title">{{ titleText }}</span>
            <h3 class="pl-1 font-semibold text-gray-900 text-22px">
              {{
                $t(
                  'components.slowSpeedAreaManagement.details.headline.details'
                )
              }}
              (#{{ slow_zone_area.id | onlyLastFive }})
            </h3>
          </div>
          <div
            class="flex items-center justify-end w-1/3 pl-2 md-max:w-full md-max:pt-3"
          >
            <oto-edit-button @click="edit" />
          </div>
        </div>
        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.slowSpeedAreaManagement.details.slowSpeedAreaName')
            }}</span>
            <span class="block mt-4 detail-value">{{
              slow_zone_area.name
            }}</span>
          </div>
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t(
                'components.slowSpeedAreaManagement.details.assignedServiceArea'
              )
            }}</span>
            <span class="block mt-4 detail-value">{{
              slow_zone_area.geofence ? slow_zone_area.geofence.name : '--'
            }}</span>
          </div>
        </div>

        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.slowSpeedAreaManagement.details.speedMode')
            }}</span>
            <span class="block mt-4 detail-value">{{
              getSpeedMode(slow_zone_area.assert_speed_mode)
            }}</span>
          </div>
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.slowSpeedAreaManagement.details.type')
            }}</span>
            <span class="block mt-4 detail-value">{{
              slow_zone_area.draw_type == 'P' ? 'Polygon' : 'Circle'
            }}</span>
          </div>
        </div>

        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.slowSpeedAreaManagement.details.address')
            }}</span>
            <span class="block mt-4 detail-value">{{
              slow_zone_area.address ? slow_zone_area.address : ''
            }}</span>
          </div>
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.slowSpeedAreaManagement.details.note')
            }}</span>
            <span class="block mt-4 detail-value">{{
              slow_zone_area.description ? slow_zone_area.description : ''
            }}</span>
          </div>
        </div>

        <div class="flex items-center md-max:flex-wrap">
          <div class="w-1/2 pl-2 pr-4 md-max:w-full md-max:px-0 md-max:py-3">
            <div
              :class="
                this.slow_zone_area.should_throttle == true
                  ? 'toggle-button-active flex items-center justify-center'
                  : 'toggle-button flex items-center justify-center'
              "
            >
              <div class="grid w-3/5">
                <span class="toggle-title">{{
                  $t('components.slowSpeedAreaManagement.details.throttle')
                }}</span>
              </div>
              <div class="w-2/5">
                <div class="flex items-center">
                  <t-toggle
                    variant="success"
                    :checked="this.slow_zone_area.should_throttle"
                    readonly
                  />
                  <span class="ml-2 text-sm font-semibold">{{
                    this.slow_zone_area.should_throttle ? 'ON' : 'OFF'
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2 pl-4 md-max:w-full md-max:pl-0">
            <div
              :class="
                this.slow_zone_area.should_trigger == true
                  ? 'toggle-button-active flex items-center justify-center'
                  : 'toggle-button flex items-center justify-center'
              "
            >
              <div class="grid w-3/5">
                <span class="toggle-title">{{
                  $t('components.slowSpeedAreaManagement.details.triggerAlarm')
                }}</span>
              </div>
              <div class="w-2/5">
                <div class="flex items-center">
                  <t-toggle
                    variant="success"
                    :checked="this.slow_zone_area.should_trigger"
                    readonly
                  />
                  <span class="ml-2 text-sm font-semibold">{{
                    this.slow_zone_area.should_trigger ? 'ON' : 'OFF'
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="
          is_full
            ? 'w-full relative'
            : 'w-1/2 relative md-max:w-full md-max:px-0'
        "
      >
        <gmap-map
          ref="map"
          :zoom="zoom"
          :center="center"
          map-type-id="terrain"
          style="width: 100%; height: 100vh;"
          @click="toggleMap"
          @zoom_changed="getCurrentZoom"
        >
          <gmap-marker
            key="current"
            :position="getLatLng(slow_zone_area.center_coords)"
            :icon="{
              url: require(`@/assets/img/areas_pin/S_icon.png`),
              scaledSize: { width: 60, height: 60 },
            }"
            @mouseover="toggleMarker(slow_zone_area, -1)"
            @click="moveCamera(slow_zone_area)"
          >
          </gmap-marker>
          <gmap-marker
            :key="index"
            v-for="(area, index) in allSlowspeedAreaGeofence"
            :position="getLatLng(area.center_coords)"
            :icon="{
              url: require(`@/assets/img/areas_pin/S_icon.png`),
              scaledSize: { width: 60, height: 60 },
            }"
            @mouseover="toggleMarker(area, index)"
            @click="moveCamera(area)"
          >
          </gmap-marker>
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <div v-html="infoContent"></div>
          </gmap-info-window>
        </gmap-map>

        <div class="area-info">
          <div
            class="flex flex-wrap items-center justify-between px-4 py-2 area-body"
          >
            <round-tab
              v-for="(item, index) in bottom_tabs"
              :key="index"
              :type="item.type"
              :name="item.name"
              v-on:changeArea="changeArea"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SlowZoneAreaConfig } from '@/config/SlowZoneAreaConfig'
import { gmapApi } from 'vue2-google-maps'
import OtoEditButton from '@/components/ui/OtoEditButton.vue'
import AddEditSlowZoneArea from './AddEditSlowZoneArea'
import { EventBus } from '@/utils/EventBus'
import { getAllSlowSpeedAreaData } from '@/services/cache/geofence'
import RoundTab from '@/components/service-area/RoundTab.vue'

export default {
  name: 'ViewSlowZoneArea',
  components: {
    OtoEditButton,
    AddEditSlowZoneArea,
    // RightAlert,
    // CardTaxStat,
    RoundTab,
  },
  data() {
    return {
      isLoading: false,
      item: {},
      form: {
        should_trigger: true,
        should_throttle: false,
        coords: null,
      },
      center: {
        lat: 10,
        lng: 10,
      },
      errors: [],
      scrollwheel: true,
      zoom: 12,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      markers: [{}],
      edited: null,
      map: null,
      drawingManager: null,
      mapDrawingMode: 'Polygonal',
      parsedPolygon: null,
      drawingOptions: {
        fillColor: 'rgba(130, 130, 145, 0.13)',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#828291',
        clickable: false,
        draggable: false,
        editable: false, // TODO: make this work with wrapper func
        zIndex: 1,
      },
      serviceDrawingOptions: {
        fillColor: '#4aff5c40',
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: '#00b44d',
        clickable: false,
        draggable: false,
        editable: false, // TODO: make this work with wrapper func
        zIndex: 1,
      },
      slow_zone_area: null,
      is_full: false,
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      alertVehicle: null,
      infoWinOpen: false,
      infoAlertOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -70,
        },
      },
      type: '',
      polygons: [],
      bottom_tabs: [
        {
          type: 'service',
          name: 'Service Area',
        },
        {
          type: 'slow_zone',
          name: 'Slow Speed Area',
        },
      ],
      allSlowspeedAreaGeofence: [],
    }
  },
  computed: {
    google: gmapApi,
    drawingType: function() {
      return [
        {
          id: 'CIRCLE',
          name: 'Circle',
        },
        {
          id: 'POLYGON',
          name: 'Polygon',
        },
      ]
    },
    id() {
      return this.$route.params.id
    },
    titleText: function() {
      return this.$t(
        'components.slowSpeedAreaManagement.details.headline.slowSpeedArea'
      )
    },
  },
  async mounted() {
    this.initFunc()
    window.addEventListener(SlowZoneAreaConfig.events.refresh, () => {
      this.initFunc()
    })
  },
  methods: {
    async initFunc() {
      this.isLoading = true
      await this.$http
        .get(SlowZoneAreaConfig.api.details(this.id))
        .then(async (res) => {
          console.log('res = ', res)
          this.slow_zone_area = res.data
          this.isLoading = false
          this.initDraw()
        })
        .catch((err) => {
          console.log('vehicle-header-err', err)
          this.isLoading = false
        })
      console.log('updated')
      // Code that will run only after the
      // entire view has been re-rendered
    },
    getSpeedMode(mode) {
      if (mode === 'L') {
        return 'Low'
      }
      if (mode === 'M') {
        return 'Medium'
      }
      if (mode === 'H') {
        return 'High'
      }
    },
    initDraw() {
      var self = this
      setTimeout(() => {
        if (!self.$refs.map) return
        console.log('getMIN')
        self.$refs.map.$mapPromise.then((map) => {
          console.log('Hitting promise with', map)
          self.map = map
          if (self.slow_zone_area != null) {
            console.log('slow = ', self.slow_zone_area)
            if (self.slow_zone_area.geofence) {
              const overlay = self.parseToOverlay(
                self.slow_zone_area.geofence.coords
              )
              self.setServiceOverlayOnMap(overlay)
            }
            console.log(
              'GOT POLYGON COORDS FROM SERVER',
              self.slow_zone_area.coords
            )
            const overlay = self.parseToOverlay(self.slow_zone_area.coords)
            self.setOverlayOnMap(overlay)
            self.setMapCenterToDrawingCenter(overlay, false)
            this.drawOtherZonesOnMap()
          }
        })
      }, 1000)
    },
    async drawOtherZonesOnMap() {
      const otherAreaBounds = []
      const otherParsedPolygons = []
      this.allSlowspeedAreaGeofence = await getAllSlowSpeedAreaData()

      this.allSlowspeedAreaGeofence.forEach((area) => {
        const overlay = this.parseToOverlay(area.coords)

        // Get bounds
        const bounds = new this.google.maps.LatLngBounds()
        for (const path of overlay) {
          bounds.extend(path)
        }

        // draw polygon
        const parsedPolygon = new this.google.maps.Polygon({
          paths: overlay,
          ...this.drawingOptions,
        })
        otherAreaBounds.push(bounds)
        parsedPolygon.setMap(this.map)
        otherParsedPolygons.push(parsedPolygon)
      })

      this.otherAreaBounds = otherAreaBounds
      this.otherParsedPolygons = otherParsedPolygons
    },
    fullMap() {
      this.is_full = !this.is_full
    },
    edit() {
      this.$http
        .get(SlowZoneAreaConfig.api.details(this.id))
        .then((res) => {
          delete res.data.created_by
          EventBus.$emit(SlowZoneAreaConfig.events.editingData, res.data)
          dispatchEvent(new Event(SlowZoneAreaConfig.events.sorToggle))
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCurrentZoom(z) {
      this.zoom = z
    },

    setServiceOverlayOnMap(payload) {
      this.parsedServicePolygon = new this.google.maps.Polygon({
        paths: payload,
        ...this.serviceDrawingOptions,
      })
      this.parsedServicePolygon.setMap(this.map)
      console.log('po = ', this.parsedServicePolygon)
    },
    parseToOverlay(coords) {
      if (!coords) return
      var coordsMorph = coords.replaceAll('{', '')
      coordsMorph = coordsMorph.replaceAll('}', '')
      var coordsArr = coordsMorph.split(',')
      if (!coordsArr.length % 2 === 0) {
        if (coordsArr[coordsArr.length - 1] == ',') {
          console.log('Hit pop')
          coordsArr.pop()
        }
      }
      // console.log("")
      var payload = []
      for (var i = 0; i < coordsArr.length; i = i + 2) {
        // console.log("lat", coordsArr[i])
        // console.log("lon", coordsArr[i+1])
        const lat = parseFloat(coordsArr[i])
        const lng = parseFloat(coordsArr[i + 1])
        if (isNaN(lat) || isNaN(lng)) continue
        payload.push({
          lat: lat,
          lng: lng,
        })
      }
      return payload
    },
    setOverlayOnMap(payload) {
      this.parsedPolygon = new this.google.maps.Polygon({
        paths: payload,
        ...this.drawingOptions,
      })
      this.parsedPolygon.setMap(this.map)
      console.log(payload)
      console.log('SET ON MAP')
    },
    setMapCenterToDrawingCenter(paths, panToCenter = true) {
      var bounds = new this.google.maps.LatLngBounds()
      for (const path of paths) {
        bounds.extend(path)
      }
      const newCenter = bounds.getCenter()
      console.log('NEW CENTER ', newCenter)
      if (panToCenter) {
        this.map.panTo(newCenter)
      } else {
        this.center.lat = newCenter.lat()
        this.center.lng = newCenter.lng()
      }
      //reset map zoom based on new poly (can't see whole poly on render if the poly is bigger then the current set zoom)
      this.map.fitBounds(bounds)
      // if (!this.parsedPolygon) return
      // const polyBounds = this.getPolygonBounds(this.parsedPolygon)
      // const newZoomLevel = this.getZoomLevelByBounds(this.map, polyBounds)
      // this.map.setZoom(newZoomLevel)
    },

    goBack() {
      this.$router.push('/geofence/slow-zone-areas')
      this.$store.dispatch('fsTable/fetchData')
    },
    changeArea(type) {
      this.parsedServicePolygon.setMap(null)
      this.parsedPolygon.setMap(null)
      if (type == this.type) {
        this.type = ''
        this.initDraw()
        return
      } else {
        this.type = type
      }

      if (!this.$refs.map) return

      this.$refs.map.$mapPromise.then((map) => {
        this.map = map
        if (type == 'service') {
          if (this.slow_zone_area.geofence) {
            const overlay = this.parseToOverlay(
              this.slow_zone_area.geofence.coords
            )
            this.setServiceOverlayOnMap(overlay)
          }
        } else {
          if (this.slow_zone_area != null) {
            const overlay = this.parseToOverlay(this.slow_zone_area.coords)
            this.setOverlayOnMap(overlay)
            this.setMapCenterToDrawingCenter(overlay, false)
          }
        }
      })
    },

    getLatLng(position) {
      if (position == '' || position == null)
        return {
          lat: 0,
          lng: 0,
        }
      let lat = Number(position.split(',')[0])
      let lng = Number(position.split(',')[1])
      return {
        lat: lat,
        lng: lng,
      }
    },

    toggleMap() {
      this.infoWinOpen = false
      // this.infoAlertOpen = false
    },

    moveCamera(area) {
      this.infoWinOpen = false
      // this.infoAlertOpen = true
      // this.alertVehicle = vehicle

      if (area.center_coords != null) {
        this.center = this.getLatLng(area.center_coords)
        this.zoom = 15
      }
    },

    // toggleAlert(vehicle) {
    //   this.infoWinOpen = false
    //   this.infoAlertOpen = true
    //   this.alertVehicle = vehicle

    //   if (vehicle.location != null) {
    //     this.center = this.getLatLng(vehicle.location)
    //     this.zoom = 15
    //   }
    // },

    toggleMarker(area, idx) {
      this.infoWindowPos = this.getLatLng(area.center_coords)
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
      this.infoContent = this.getInfoWindowContent(area)
    },

    getInfoWindowContent: function(item) {
      //work from here

      return `
        <div class="card">
          <div class="card-content">
            <div class="flex items-center h-6 pl-2">
              <span class="card-title">Slow speed Area Name:</span>
              <span class="ml-2 card-text ">
              <a href="/geofence/slow-zone-areas/${
                item.id
              }" class="font-semibold text-blue-600 capitalize " target="_blank"> ${
        item.name == undefined ? ' ' : item.name
      } </a>
              </span>
            </div>
            <div class="flex items-center h-6 pl-2 mt-1">
              <span class="card-title">Address:</span>
              <span class="ml-2 card-text">${item.address}</span>
            </div>

            <div class="flex items-center h-6 pl-2 mt-1">
              <span class="card-title">Latitude:</span>
              <span class="ml-2 card-text">${
                this.getLatLng(item.center_coords).lat
              }</span>
            </div>

            <div class="flex items-center h-6 pl-2">
              <span class="card-title">Longtitude:</span>
              <span class="ml-2 card-text">${
                this.getLatLng(item.center_coords).lng
              }</span>
            </div>

            <div class="flex items-center h-6 pl-2 mt-1">
              <span class="card-title">Active Status:</span>
              <span class="ml-2 card-text font-semibold">${
                item.is_active
                  ? '<span class="text-green-600">Yes<span>'
                  : '<span class="text-gray-600">No<span>'
              }</span>
            </div>
          </div>
        </div>
      `
    },
  },
}
</script>

<style lang="scss" scoped>
.feature-item {
  display: flex;
  justify-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding: 4px 0; // 15px 0?

  & .left {
    width: 65%;
    padding-right: 0.5rem;
    font-size: 0.875rem;
  }

  & .right {
    width: 35%;
    padding-left: 0.5rem;
  }
}
.toggle-button-active {
  border: 1px solid #1bca09;
  width: 100%;
  height: 140px;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
}
.toggle-button {
  width: 100%;
  height: 140px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
}
.toggle-title {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.toggle-description {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 10px;
  @apply text-gray-600;
}
.detail-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.detail-value {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #787881;
}
.title {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9393a2;
}
.area-info {
  position: absolute;
  bottom: 15px;
  width: 100%;
  min-height: 40px;
  display: flex;
  .area-body {
    width: 270px;
    height: 100%;
    margin-left: 20px;
    background: white;
    border-radius: 5px;
    box-shadow: 1px 1px 6px 0px #757575bf;
    .service-area-circle {
      width: 20px;
      height: 20px;
      border-radius: 100px;
      background: #dff7e4;
      border: 1px solid #00b44d;
      margin-right: 5px;
    }
    .parking-area-circle {
      width: 20px;
      height: 20px;
      border-radius: 100px;
      background: #dff7e4;
      border: 1px solid #00acff;
      margin-right: 5px;
    }
    .restricted-area-circle {
      width: 20px;
      height: 20px;
      border-radius: 100px;
      background: #ffd7bb;
      border: 1px solid #ff7c10;
      margin-right: 5px;
    }
    .slow-area-circle {
      width: 20px;
      height: 20px;
      border-radius: 100px;
      background: #ffe4e4;
      border: 1px solid #ff0000;
      margin-right: 5px;
    }
    .bottom-area-text {
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #2e2f40;
    }
  }
  .full-map-button {
    width: 150px;
    background: white;
    height: 40px;
    margin-left: 30px;
    border-radius: 5px;
    display: flex;
    box-shadow: 1px 1px 6px 0px #757575bf;
    cursor: pointer;

    font-family: Roboto;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #21212a;
  }
}
.active_service {
  color: #00b44d !important;
}
.active_parking {
  color: #00acff !important;
}
.active_restricted {
  color: #ff7c10 !important;
}
.active_slow_zone {
  color: #ff0000 !important;
}
@media (max-width: 990px) {
  .hidden-class {
    display: none !important;
  }
}
</style>
